var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M24 28Q25.65 28 26.825 26.825Q28 25.65 28 24Q28 22.35 26.825 21.175Q25.65 20 24 20Q22.35 20 21.175 21.175Q20 22.35 20 24Q20 25.65 21.175 26.825Q22.35 28 24 28ZM16 36H32V34.85Q32 33.65 31.35 32.65Q30.7 31.65 29.55 31.15Q28.25 30.6 26.875 30.3Q25.5 30 24 30Q22.5 30 21.125 30.3Q19.75 30.6 18.45 31.15Q17.3 31.65 16.65 32.65Q16 33.65 16 34.85ZM37 44H11Q9.8 44 8.9 43.1Q8 42.2 8 41V7Q8 5.8 8.9 4.9Q9.8 4 11 4H28.05L40 15.95V41Q40 42.2 39.1 43.1Q38.2 44 37 44ZM37 41Q37 41 37 41Q37 41 37 41V17.3L26.7 7H11Q11 7 11 7Q11 7 11 7V41Q11 41 11 41Q11 41 11 41ZM11 41Q11 41 11 41Q11 41 11 41V7Q11 7 11 7Q11 7 11 7V17.3V41Q11 41 11 41Q11 41 11 41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.ccc81f74d7f415bb7a694acc1c317bf7.svg";
export { ForwardRef as ReactComponent };